"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimelineMarkerType = void 0;
var TimelineMarkerType = {
  Today: 'Today',
  Custom: 'Custom',
  Cursor: 'Cursor'
};
exports.TimelineMarkerType = TimelineMarkerType;